// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.property.SatelliteWebLandlordPropertyHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordPropertyHandler_getAddressDetails,
  SatelliteWebLandlordPropertyHandler_getAddressDetails_Path,
  SatelliteWebLandlordPropertyHandler_getListingPerformance,
  SatelliteWebLandlordPropertyHandler_getListingPerformance_Path,
  SatelliteWebLandlordPropertyHandler_search,
  SatelliteWebLandlordPropertyHandler_search_Path,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
  SatelliteWebLandlordPropertyGetAddressDetailsResponseDto,
  SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
  SatelliteWebLandlordPropertyGetListingPerformanceResponseDto,
  SatelliteWebLandlordPropertySearchRequestDto,
  SatelliteWebLandlordPropertySearchResponseDto,
} from '@zg-rentals/ts-satellite-client';

export type SatelliteWebLandlordPropertyHandler_getAddressDetails_Options = UseQueryOptions<
  SatelliteWebLandlordPropertyGetAddressDetailsResponseDto,
  unknown,
  SatelliteWebLandlordPropertyGetAddressDetailsResponseDto,
  readonly [string, SatelliteWebLandlordPropertyGetAddressDetailsRequestDto]
>;

const SatelliteWebLandlordPropertyHandler_getAddressDetails_GetKey = (
  postData: SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
) => [SatelliteWebLandlordPropertyHandler_getAddressDetails_Path, postData] as const;

export const SatelliteWebLandlordPropertyHandler_getAddressDetails_queryOptions = (
  postData: SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordPropertyHandler_getAddressDetails_GetKey(postData),
    queryFn: () => SatelliteWebLandlordPropertyHandler_getAddressDetails(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordPropertyHandler_getAddressDetails = (
  postData: SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordPropertyHandler_getAddressDetails_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordPropertyHandler_getAddressDetails_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordPropertyHandler_getAddressDetails.getKey =
  SatelliteWebLandlordPropertyHandler_getAddressDetails_GetKey;

export type SatelliteWebLandlordPropertyHandler_getListingPerformance_Options = UseQueryOptions<
  SatelliteWebLandlordPropertyGetListingPerformanceResponseDto,
  unknown,
  SatelliteWebLandlordPropertyGetListingPerformanceResponseDto,
  readonly [string, SatelliteWebLandlordPropertyGetListingPerformanceRequestDto]
>;

const SatelliteWebLandlordPropertyHandler_getListingPerformance_GetKey = (
  postData: SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
) => [SatelliteWebLandlordPropertyHandler_getListingPerformance_Path, postData] as const;

export const SatelliteWebLandlordPropertyHandler_getListingPerformance_queryOptions = (
  postData: SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordPropertyHandler_getListingPerformance_GetKey(postData),
    queryFn: () => SatelliteWebLandlordPropertyHandler_getListingPerformance(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordPropertyHandler_getListingPerformance = (
  postData: SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordPropertyHandler_getListingPerformance_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordPropertyHandler_getListingPerformance_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordPropertyHandler_getListingPerformance.getKey =
  SatelliteWebLandlordPropertyHandler_getListingPerformance_GetKey;

export type SatelliteWebLandlordPropertyHandler_search_Options = UseQueryOptions<
  SatelliteWebLandlordPropertySearchResponseDto,
  unknown,
  SatelliteWebLandlordPropertySearchResponseDto,
  readonly [string, SatelliteWebLandlordPropertySearchRequestDto]
>;

const SatelliteWebLandlordPropertyHandler_search_GetKey = (postData: SatelliteWebLandlordPropertySearchRequestDto) =>
  [SatelliteWebLandlordPropertyHandler_search_Path, postData] as const;

export const SatelliteWebLandlordPropertyHandler_search_queryOptions = (
  postData: SatelliteWebLandlordPropertySearchRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordPropertyHandler_search_GetKey(postData),
    queryFn: () => SatelliteWebLandlordPropertyHandler_search(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordPropertyHandler_search = (
  postData: SatelliteWebLandlordPropertySearchRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordPropertyHandler_search_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordPropertyHandler_search_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordPropertyHandler_search.getKey = SatelliteWebLandlordPropertyHandler_search_GetKey;
